<div class="c-adventureQuestChallengeBox">
  @if (eventChallengeStatus) {
    <div
      class="c-adventureQuestChallengeBox__background"
      theming
      themingGroup="adventurequest"
      themingAsset="box"
      [themingOverride]="event?.assets">
      @if (eventChallengeStatus.isGeneric) {
        <div
          class="c-adventureQuestChallengeBox__gameIcon no-pointer"
          theming
          themingGroup="tournament"
          themingAsset="generic-icon"
          [themingOverride]="event?.assets"></div>
      } @else {
        <div
          class="c-adventureQuestChallengeBox__gameIcon"
          [ngStyle]="gameIcon"
          avoidMulticlick
          (safeClick)="goToGame()"></div>
      }

      <div class="c-adventureQuestChallengeBox__text">
        <span class="text challengeText">
          {{
            challengeText
              | translate
                : {
                    x: eventChallengeStatus.total | notRoundingBeautifyNumber: ('common.culture' | translate),
                    y: eventChallengeStatus.bonusGameTitle ? eventChallengeStatus.bonusGameTitle : ''
                  }
              | uppercase
          }}
        </span>
      </div>
      <div class="c-adventureQuestChallengeBox__progress">
        @if (eventChallengeStatus.minBet !== 0) {
          <span class="text minBet"
            >{{ 'home.live-ops.gamechallenges.min-stake-of' | translate }}
            {{ eventChallengeStatus.minBet | number: '1.0-0' : ('common.culture' | translate) }}</span
          >
        }
        <slotcom-progress-bar
          [classes]="['c-progress-bar--green-black']"
          [currentProgress]="eventChallengeStatus.current"
          [totalProgress]="eventChallengeStatus.total"
          [completed]="eventChallengeStatus.finished ? eventChallengeStatus.finished : true">
          <span class="text percent">
            {{
              eventChallengeStatus.current < eventChallengeStatus.total
                ? (eventChallengeStatus.current | notRoundingBeautifyNumber: ('common.culture' | translate)) +
                  ' / ' +
                  (eventChallengeStatus.total | notRoundingBeautifyNumber: ('common.culture' | translate))
                : ('home.live-ops.gamechallenges.completed-2' | translate | uppercase)
            }}
          </span>
        </slotcom-progress-bar>
      </div>
      <slotcom-button
        class="c-button--pink"
        (safeClick)="eventChallengeStatus.isGeneric ? closeModal() : goToGame()"
        audioType="functionality">
        {{ 'common.play' | translate | uppercase }}
      </slotcom-button>
    </div>
  } @else {
    <div class="c-adventureQuestChallengeBox--noChallenges">
      <span class="text congrats">{{ 'home.live-ops.adventure-quest.congrats' | translate | uppercase }}</span>
      <span class="text noChallenges">{{ 'home.live-ops.adventure-quest.text-1' | translate }}</span>
      <span class="text noChallenges">{{ 'home.live-ops.adventure-quest.text-2' | translate }}</span>
    </div>
  }
</div>

<ng-template #noChallenges>
  <div class="c-adventureQuestChallengeBox--noChallenges">
    <span class="text congrats">{{ 'home.live-ops.adventure-quest.congrats' | translate | uppercase }}</span>
    <span class="text noChallenges">{{ 'home.live-ops.adventure-quest.text-1' | translate }}</span>
    <span class="text noChallenges">{{ 'home.live-ops.adventure-quest.text-2' | translate }}</span>
  </div>
</ng-template>
